import React from "react";
import "../../css/Wireframe.css";
import Footer from "../../components/Footer";
import Banner from "../../components/Banner";
import axios from "axios";
import Select from "react-select";
import Spinner from "../../components/Spinner";

// Helper regex/strings, inlined
const emailRegex =
  /^[\w.!#$%&'*+/=?^`{|}~-]+@[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?(?:\.[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?)+$/i;
const emailError = "Please enter a valid email address (e.g. name@example.com)";
// eslint-disable-next-line no-useless-escape
const passwordRegex =
  // eslint-disable-next-line no-useless-escape
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
const passwordError =
  "Password must be at least 8 characters, with uppercase, lowercase, number, and symbol.";
const usernameRegex = /^(?!\s*$)[-_a-zA-Z0-9 ]*$/;
const usernameError =
  "Username should only contain letters, digits, dash, or underscore";
const nationalIdRegex = /^\d{2}-\d{6,7}[A-Z]\d{2}$/;
const ogPlaceholder = "00-000000(0)A00";
const placeholder1 = "00-000000A00";
const placeholder2 = "00-0000000A00";

function dynamicNationalIdError(id) {
  const start = "Accepted format for national ID is ";
  let last = "";
  if (id.length >= 10 && /[A-Z]/.test(id[9])) {
    last = id + placeholder1.substring(id.length);
  } else if (id.length >= 10) {
    last = id + placeholder2.substring(id.length);
  } else {
    last = id + ogPlaceholder.substring(id.length);
  }
  return start + last;
}

function getNestedValue(obj, path) {
  return path.split(".").reduce((acc, key) => acc && acc[key], obj);
}
function setNestedValue(obj, path, value) {
  const keys = path.split(".");
  const lastKey = keys.pop();
  const newObj = { ...obj };
  let curr = newObj;
  for (const k of keys) {
    curr[k] = { ...curr[k] };
    curr = curr[k];
  }
  curr[lastKey] = value;
  return newObj;
}

function formatNationalId(e, currentObject, field, isZimbabwean = true) {
  let currentValue = String(getNestedValue(currentObject, field) || "");
  let newValue = currentValue;
  let newPlaceholder =
    currentValue + ogPlaceholder.substring(currentValue.length);
  let error = "";
  e = e.toUpperCase();
  if (!isZimbabwean) {
    const updatedObject = setNestedValue(currentObject, field, e);
    return { newPlaceholder, error, updatedObject };
  }
  if (e.length > currentValue.length && nationalIdRegex.test(currentValue)) {
    return { newPlaceholder, error, updatedObject: currentObject };
  }
  if (nationalIdRegex.test(e)) {
    newValue = e;
    newPlaceholder = e;
  } else if (
    nationalIdRegex.test(e + placeholder1.substring(e.length)) ||
    nationalIdRegex.test(e + placeholder2.substring(e.length))
  ) {
    if (e.length >= 10) {
      if (/[A-Z]/.test(e[9])) {
        newValue = e;
        newPlaceholder = e + placeholder1.substring(e.length);
      } else {
        newValue = e;
        newPlaceholder = e + placeholder2.substring(e.length);
      }
    } else if (e.length === 2 && currentValue.length < 2) {
      newValue = e + "-";
      newPlaceholder = newValue + ogPlaceholder.substring(newValue.length);
    } else {
      newValue = e;
      newPlaceholder = e + ogPlaceholder.substring(e.length);
    }
  } else {
    error = dynamicNationalIdError(currentValue);
  }
  const updatedObject = setNestedValue(currentObject, field, newValue);
  return { newPlaceholder, error, updatedObject };
}

const API = localStorage.getItem("assethost");

export default class Corporate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      tradingName: "",
      registrationNumber: "",
      primaryContactFirstname: "",
      primaryContactSurname: "",
      primaryContactRole: "",
      primaryContactEmail: "",
      primaryContactCellphone: "",
      primaryContactNationality: "",
      primaryContactIdentification: "",
      primaryContactIdentificationDocument: null,
      primaryContactPassportNumber: "",
      primaryContactPassportDocument: null,
      billingContactFirstname: "",
      billingContactSurname: "",
      billingContactRole: "",
      billingContactEmail: "",
      billingContactCellphone: "",
      billingContactNationality: "",
      billingContactIdentification: "",
      billingContactIdentificationDocument: null,
      billingContactPassportNumber: "",
      billingContactPassportDocument: null,
      physicalAddress: "",
      townCityId: 0,
      certificateOfIncorporation: null,
      cr14: null,
      username: "",
      password: "",
      passwordConfirm: "",
      errors: {},
      companyLookupData: {},
      idPlaceholderPrimary: ogPlaceholder,
      idPlaceholderBilling: ogPlaceholder,
      msg: "",
      toastColor: "",
      loading: false,
    };
    this.handleRegister = this.handleRegister.bind(this);
    this.handlePrimaryNationalId = this.handlePrimaryNationalId.bind(this);
    this.handleBillingNationalId = this.handleBillingNationalId.bind(this);
    this.getCompanyLookupData = this.getCompanyLookupData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  componentDidMount() {
    this.getCompanyLookupData();
  }

  getCompanyLookupData() {
    var self = this;
    axios
      .get(API + "/register/getcompanydropdownlists")
      .then(function (response) {
        self.setState({ companyLookupData: response.data || {} });
      })
      .catch(function (error) {
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to get lookup data. Refresh page or contact administrator.",
          toastColor: "danger",
        });
      });
  }

  isZimbabweanPrimary() {
    return this.state.primaryContactNationality === "ZW";
  }
  isZimbabweanBilling() {
    return this.state.billingContactNationality === "ZW";
  }

  // PatientAction.js style explicit validation, NO arrays, NO ++!
  validate() {
    const s = this.state;
    let valid = true;
    const errors = {};

    // Each required field is validated with explicit if order (patientaction.js style):

    if (!s.name || !s.name.trim()) {
      errors.name = "Name is required";
      valid = false;
    }
    if (!s.registrationNumber || !s.registrationNumber.trim()) {
      errors.registrationNumber = "Registration No is required";
      valid = false;
    }
    if (!s.physicalAddress || !s.physicalAddress.trim()) {
      errors.physicalAddress = "Physical Address is required";
      valid = false;
    }
    if (!s.townCityId || s.townCityId === 0) {
      errors.townCityId = "Town/City is required";
      valid = false;
    }
    if (!s.username || !s.username.trim()) {
      errors.username = "Username is required";
      valid = false;
    } else if (!usernameRegex.test(s.username)) {
      errors.username = usernameError;
      valid = false;
    }
    if (!s.password || !s.password.trim()) {
      errors.password = "Password is required";
      valid = false;
    } else if (!passwordRegex.test(s.password)) {
      errors.password = passwordError;
      valid = false;
    }
    if (!s.passwordConfirm || !s.passwordConfirm.trim()) {
      errors.passwordConfirm = "Password Confirm is required";
      valid = false;
    } else if (s.password !== s.passwordConfirm) {
      errors.passwordConfirm = "Passwords do not match";
      valid = false;
    } else if (!passwordRegex.test(s.passwordConfirm)) {
      errors.passwordConfirm = passwordError;
      valid = false;
    }
    // Primary Contact validation
    if (!s.primaryContactFirstname || !s.primaryContactFirstname.trim()) {
      errors.primaryContactFirstname = "Primary Contact Firstname is required";
      valid = false;
    }
    if (!s.primaryContactSurname || !s.primaryContactSurname.trim()) {
      errors.primaryContactSurname = "Primary Contact Surname is required";
      valid = false;
    }
    if (!s.primaryContactRole || !s.primaryContactRole.trim()) {
      errors.primaryContactRole = "Primary Contact Role is required";
      valid = false;
    }
    if (!s.primaryContactEmail || !s.primaryContactEmail.trim()) {
      errors.primaryContactEmail = "Primary Contact Email is required";
      valid = false;
    } else if (!emailRegex.test(s.primaryContactEmail)) {
      errors.primaryContactEmail = emailError;
      valid = false;
    }
    if (!s.primaryContactCellphone || !s.primaryContactCellphone.trim()) {
      errors.primaryContactCellphone = "Primary Contact Cellphone is required";
      valid = false;
    }
    if (!s.primaryContactNationality || !s.primaryContactNationality.trim()) {
      errors.primaryContactNationality =
        "Primary Contact Nationality is required";
      valid = false;
    }
    if (
      this.isZimbabweanPrimary() &&
      (!s.primaryContactIdentification ||
        !s.primaryContactIdentification.trim())
    ) {
      errors.primaryContactIdentification =
        "Primary Contact National ID is required";
      valid = false;
    } else if (
      this.isZimbabweanPrimary() &&
      !nationalIdRegex.test(s.primaryContactIdentification)
    ) {
      errors.primaryContactIdentification = dynamicNationalIdError(
        s.primaryContactIdentification
      );
      valid = false;
    }

    if (
      !this.isZimbabweanPrimary() &&
      (!s.primaryContactPassportNumber ||
        !s.primaryContactPassportNumber.trim())
    ) {
      errors.primaryContactPassportNumber =
        "Primary Contact Passport Number is required";
      valid = false;
    }
    // Billing Contact validation
    if (!s.billingContactFirstname || !s.billingContactFirstname.trim()) {
      errors.billingContactFirstname = "Billing Contact Firstname is required";
      valid = false;
    }
    if (!s.billingContactSurname || !s.billingContactSurname.trim()) {
      errors.billingContactSurname = "Billing Contact Surname is required";
      valid = false;
    }
    if (!s.billingContactRole || !s.billingContactRole.trim()) {
      errors.billingContactRole = "Billing Contact Role is required";
      valid = false;
    }
    if (!s.billingContactEmail || !s.billingContactEmail.trim()) {
      errors.billingContactEmail = "Billing Contact Email is required";
      valid = false;
    } else if (!emailRegex.test(s.billingContactEmail)) {
      errors.billingContactEmail = emailError;
      valid = false;
    }
    if (!s.billingContactCellphone || !s.billingContactCellphone.trim()) {
      errors.billingContactCellphone = "Billing Contact Cellphone is required";
      valid = false;
    }
    if (!s.billingContactNationality || !s.billingContactNationality.trim()) {
      errors.billingContactNationality =
        "Billing Contact Nationality is required";
      valid = false;
    }
    if (
      this.isZimbabweanBilling() &&
      (!s.billingContactIdentification ||
        !s.billingContactIdentification.trim())
    ) {
      errors.billingContactIdentification =
        "Billing Contact National ID is required";
      valid = false;
    } else if (
      this.isZimbabweanBilling() &&
      !nationalIdRegex.test(s.billingContactIdentification)
    ) {
      errors.billingContactIdentification = dynamicNationalIdError(
        s.billingContactIdentification
      );
      valid = false;
    }

    if (
      !this.isZimbabweanBilling() &&
      (!s.billingContactPassportNumber ||
        !s.billingContactPassportNumber.trim())
    ) {
      errors.billingContactPassportNumber =
        "Billing Contact Passport Number is required";
      valid = false;
    }
    this.setState({ errors, valid });
    return valid;
  }

  handleRegister(e) {
    if (e) e.preventDefault();
    this.setState({ loading: true, msg: "", toastColor: "" });
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      this.setState({ loading: false });
      return;
    }
    const { corporate } = this.state;
    var self = this;
    let request = new FormData();
    request.append("user.username", corporate.username);
    request.append("user.password", corporate.password);
    request.append("user.userType", "COMPANY");
    request.append(
      "user.fullName",
      [corporate.primaryContactFirstname, corporate.primaryContactSurname].join(
        " "
      )
    );
    request.append("user.mobileVerified", "NO");
    request.append("user.activeStatus", "YES");
    request.append("user.emailVerified", "NO");
    request.append("user.isPaidService", "NO");
    request.append("profile.companyName", corporate.name);
    request.append("profile.tradingName", corporate.tradingName || "");
    request.append("profile.registrationNumber", corporate.registrationNumber);
    request.append("profile.townCityId", String(corporate.townCityId));
    request.append("profile.physicalAddress", corporate.physicalAddress);
    request.append(
      "profile.primaryContactFirstName",
      corporate.primaryContactFirstname
    );
    request.append(
      "profile.primaryContactSurname",
      corporate.primaryContactSurname
    );
    request.append(
      "profile.primaryContactIdNumber",
      corporate.primaryContactIdentification
    );
    request.append(
      "profile.primaryPassportNumber",
      corporate.primaryContactPassportNumber
    );
    request.append("profile.primaryContactRole", corporate.primaryContactRole);
    request.append(
      "profile.primaryContactNumber",
      corporate.primaryContactCellphone
    );
    request.append(
      "profile.primaryContactEmail",
      corporate.primaryContactEmail
    );
    request.append(
      "profile.billingContactFirstName",
      corporate.billingContactFirstname
    );
    request.append(
      "profile.billingContactSurname",
      corporate.billingContactSurname
    );
    request.append(
      "profile.billingContactIdNumber",
      corporate.billingContactIdentification
    );
    request.append(
      "profile.billingContactPassportNumber",
      corporate.billingContactPassportNumber
    );
    request.append(
      "profile.billingContactEmail",
      corporate.billingContactEmail
    );
    request.append(
      "profile.billingContactNumber",
      corporate.billingContactCellphone
    );
    request.append("profile.companyType", "CORPORATE");
    if (corporate.primaryContactIdentificationDocument)
      request.append(
        "primaryContactIdentityDocument",
        corporate.primaryContactIdentificationDocument
      );
    if (corporate.primaryContactPassportDocument)
      request.append(
        "primaryContactPassportDocument",
        corporate.primaryContactPassportDocument
      );
    if (corporate.billingContactIdentificationDocument)
      request.append(
        "billingContactIdentificationDocument",
        corporate.billingContactIdentificationDocument
      );
    if (corporate.billingContactPassportDocument)
      request.append(
        "billingContactPassportDocument",
        corporate.billingContactPassportDocument
      );
    if (corporate.certificateOfIncorporation)
      request.append(
        "certificateIncorpFile",
        corporate.certificateOfIncorporation
      );
    if (corporate.cr14) request.append("cr14File", corporate.cr14);
    axios
      .post(API + "/register/companysave", request)
      .then(function (response) {
        if (response.data.success) {
          self.setState({
            msg: "Registration successful! Redirecting to login...",
            toastColor: "success",
          });
          setTimeout(() => {
            window.location.href = "/";
          }, 1700);
        } else {
          self.setState({
            msg: response.data.message || "Registration failed",
            toastColor: "danger",
          });
          if (
            response.data.message &&
            response.data.message.includes("username already exist")
          ) {
            self.setState({
              errors: { ...self.state.errors, username: response.data.message },
            });
          }
        }
      })
      .catch(function (error) {
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Registration failed. Please try again.",
          toastColor: "danger",
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  handleChange(e) {
    const { name, value, type, files } = e.target;
    const newValue = type === "file" ? files[0] : value;
    this.setState({ [name]: newValue }, this.validate);
  }
  handleSelect(name, value) {
    this.setState({ [name]: value }, this.validate);
  }

  handlePrimaryNationalId(eValue, field = "primaryContactIdentification") {
    const { newPlaceholder, error, updatedObject } = formatNationalId(
      eValue,
      this.state,
      field,
      this.isZimbabweanPrimary()
    );
    this.setState(
      {
        [field]: updatedObject[field],
        ...(field === "primaryContactIdentification"
          ? { idPlaceholderPrimary: newPlaceholder }
          : {}),
        errors: { ...this.state.errors, primaryContactIdentification: error },
      },
      this.validate
    );
  }

  handleBillingNationalId(eValue, field = "billingContactIdentification") {
    const { newPlaceholder, error, updatedObject } = formatNationalId(
      eValue,
      this.state,
      field,
      this.isZimbabweanBilling()
    );
    this.setState(
      {
        [field]: updatedObject[field],
        ...(field === "billingContactIdentification"
          ? { idPlaceholderBilling: newPlaceholder }
          : {}),
        errors: { ...this.state.errors, billingContactIdentification: error },
      },
      this.validate
    );
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }
    if (s.loading) {
      return <Spinner className="" />;
    }
    return (
      <div className="min-h-screen flex flex-col ">
        <Banner title="Register as Corporate" />
        {divMsg}
        <form
          className="flex flex-col items-center w-full mt-2"
          autoComplete="off"
          onSubmit={this.handleRegister}
        >
          <div className="w-full max-w-5xl">
            <div className="grid grid-cols-2 gap-x-8 gap-y-4">
              <div className="input-group">
                <label className="input-group-text">Name</label>
                <input
                  name="name"
                  className={`form-control ${
                    s.errors.name ? " !border-red-500" : ""
                  }`}
                  value={s.name}
                  onChange={this.handleChange}
                  required
                  autoFocus
                />
                {s.errors.name && (
                  <span className="input-group-error">{s.errors.name}</span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Registration No</label>
                <input
                  name="registrationNumber"
                  className={`form-control ${
                    s.errors.registrationNumber ? " !border-red-500" : ""
                  }`}
                  value={s.registrationNumber}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.registrationNumber && (
                  <span className="input-group-error">
                    {s.errors.registrationNumber}
                  </span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Trading Name</label>
                <input
                  name="tradingName"
                  className={`form-control ${
                    s.errors.tradingName ? " !border-red-500" : ""
                  }`}
                  value={s.tradingName}
                  onChange={this.handleChange}
                />
                {s.errors.tradingName && (
                  <span className="input-group-error">
                    {s.errors.tradingName}
                  </span>
                )}
              </div>
              <div></div>
            </div>
          </div>
          {/* Primary Contact Section */}
          <div className="form-blue-card mt-3">
            <div className="form-blue-card-grid space-y-3">
              <div className="col-span-2 font-bold">Primary Contact</div>
              <div className="input-group">
                <label className="input-group-text">Firstname</label>
                <input
                  name="primaryContactFirstname"
                  className={`form-control ${
                    s.errors.primaryContactFirstname ? " !border-red-500" : ""
                  }`}
                  value={s?.primaryContactFirstname}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.primaryContactFirstname && (
                  <span className="input-group-error">
                    {s.errors.primaryContactFirstname}
                  </span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Surname</label>
                <input
                  name="primaryContactSurname"
                  className={`form-control ${
                    s.errors.primaryContactSurname ? " !border-red-500" : ""
                  }`}
                  value={s?.primaryContactSurname}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.primaryContactSurname && (
                  <span className="input-group-error">
                    {s.errors.primaryContactSurname}
                  </span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Role</label>
                <input
                  name="primaryContactRole"
                  className={`form-control ${
                    s.errors.primaryContactRole ? " !border-red-500" : ""
                  }`}
                  value={s?.primaryContactRole}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.primaryContactRole && (
                  <span className="input-group-error">
                    {s.errors.primaryContactRole}
                  </span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Email</label>
                <input
                  name="primaryContactEmail"
                  className={`form-control ${
                    s.errors.primaryContactEmail ? " !border-red-500" : ""
                  }`}
                  type="email"
                  value={s?.primaryContactEmail}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.primaryContactEmail && (
                  <span className="input-group-error">
                    {s.errors.primaryContactEmail}
                  </span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Cellphone</label>
                <input
                  name="primaryContactCellphone"
                  className={`form-control ${
                    s.errors.primaryContactCellphone ? " !border-red-500" : ""
                  }`}
                  value={s?.primaryContactCellphone}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.primaryContactCellphone && (
                  <span className="input-group-error">
                    {s.errors.primaryContactCellphone}
                  </span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Nationality</label>
                <Select
                  name="primaryContactNationality"
                  value={(s.companyLookupData.countrys || []).find(
                    ({ value }) => value === s.primaryContactNationality
                  )}
                  onChange={(e) => {
                    this.handlePrimaryNationalId("");
                    this.handlePrimaryNationalId(
                      "",
                      "primaryContactPassportNumber"
                    );
                    this.setState({ idPlaceholderPrimary: ogPlaceholder });
                    this.handleSelect(
                      "primaryContactNationality",
                      e ? e.value : ""
                    );
                  }}
                  className={`form-control ${
                    s.errors.primaryContactNationality ? " !border-red-500" : ""
                  }`}
                  required
                  options={s.companyLookupData.countrys || []}
                />
                {s.errors.primaryContactNationality && (
                  <span className="input-group-error">
                    {s.errors.primaryContactNationality}
                  </span>
                )}
              </div>
              {!!s.primaryContactNationality && this.isZimbabweanPrimary() ? (
                <>
                  <div className="input-group">
                    <label className="input-group-text">National ID</label>
                    <input
                      name="primaryContactIdentification"
                      className={`form-control ${
                        s.errors.primaryContactIdentification
                          ? " !border-red-500"
                          : ""
                      }`}
                      value={s?.primaryContactIdentification}
                      placeholder={s.idPlaceholderPrimary}
                      onChange={(e) =>
                        this.handlePrimaryNationalId(e.target.value)
                      }
                      required
                    />
                    {s.errors.primaryContactIdentification && (
                      <span className="input-group-error">
                        {s.errors.primaryContactIdentification}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label
                      htmlFor="primaryContactIdentificationDocument"
                      className="input-group-text"
                    >
                      National ID
                    </label>
                    <input
                      name="primaryContactIdentificationDocument"
                      className={`form-control${
                        s.errors.primaryContactIdentificationDocument
                          ? " !border-red-500"
                          : ""
                      }`}
                      type="file"
                      id="primaryContactIdentificationDocument"
                      onChange={this.handleChange}
                      accept=".pdf,image/*"
                    />
                    {s.errors.primaryContactIdentificationDocument && (
                      <span className="input-group-error">
                        {s.errors.primaryContactIdentificationDocument}
                      </span>
                    )}
                  </div>
                </>
              ) : !!s.primaryContactNationality ? (
                <>
                  <div className="input-group">
                    <label className="input-group-text">Passport Number</label>
                    <input
                      name="primaryContactPassportNumber"
                      className={`form-control ${
                        s.errors.primaryContactPassportNumber
                          ? " !border-red-500"
                          : ""
                      }`}
                      value={s?.primaryContactPassportNumber}
                      onChange={(e) =>
                        this.handlePrimaryNationalId(
                          e.target.value,
                          "primaryContactPassportNumber"
                        )
                      }
                      required
                    />
                    {s.errors.primaryContactPassportNumber && (
                      <span className="input-group-error">
                        {s.errors.primaryContactPassportNumber}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label
                      htmlFor="primaryContactIdentificationDocument"
                      className="input-group-text"
                    >
                      Passport Document(s)
                    </label>
                    <input
                      name="primaryContactIdentificationDocument"
                      className={`form-control${
                        s.errors.primaryContactIdentificationDocument
                          ? " !border-red-500"
                          : ""
                      }`}
                      type="file"
                      id="primaryContactIdentificationDocument"
                      onChange={this.handleChange}
                      accept=".pdf,image/*"
                    />
                    {s.errors.primaryContactIdentificationDocument && (
                      <span className="input-group-error">
                        {s.errors.primaryContactIdentificationDocument}
                      </span>
                    )}
                  </div>
                </>
              ) : null}
            </div>
          </div>

          {/* Billing Contact Section */}
          <div className="form-blue-card mt-3">
            <div className="form-blue-card-grid space-y-3">
              <div className="col-span-2 font-bold">Billing Contact</div>
              <div className="input-group">
                <label className="input-group-text">Firstname</label>
                <input
                  name="billingContactFirstname"
                  className={`form-control ${
                    s.errors.billingContactFirstname ? " !border-red-500" : ""
                  }`}
                  value={s?.billingContactFirstname}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.billingContactFirstname && (
                  <span className="input-group-error">
                    {s.errors.billingContactFirstname}
                  </span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Surname</label>
                <input
                  name="billingContactSurname"
                  className={`form-control ${
                    s.errors.billingContactSurname ? " !border-red-500" : ""
                  }`}
                  value={s?.billingContactSurname}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.billingContactSurname && (
                  <span className="input-group-error">
                    {s.errors.billingContactSurname}
                  </span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Role</label>
                <input
                  name="billingContactRole"
                  className={`form-control ${
                    s.errors.billingContactRole ? " !border-red-500" : ""
                  }`}
                  value={s?.billingContactRole}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.billingContactRole && (
                  <span className="input-group-error">
                    {s.errors.billingContactRole}
                  </span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Email</label>
                <input
                  name="billingContactEmail"
                  className={`form-control ${
                    s.errors.billingContactEmail ? " !border-red-500" : ""
                  }`}
                  type="email"
                  value={s?.billingContactEmail}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.billingContactEmail && (
                  <span className="input-group-error">
                    {s.errors.billingContactEmail}
                  </span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Cellphone</label>
                <input
                  name="billingContactCellphone"
                  className={`form-control ${
                    s.errors.billingContactCellphone ? " !border-red-500" : ""
                  }`}
                  value={s?.billingContactCellphone}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.billingContactCellphone && (
                  <span className="input-group-error">
                    {s.errors.billingContactCellphone}
                  </span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Nationality</label>
                <Select
                  name="billingContactNationality"
                  value={(s.companyLookupData.townCitys || []).find(
                    ({ value }) => value === s.billingContactNationality
                  )}
                  onChange={(e) => {
                    this.handleBillingNationalId("");
                    this.handleBillingNationalId(
                      "",
                      "billingContactPassportNumber"
                    );
                    this.setState({ idPlaceholderBilling: ogPlaceholder });
                    this.handleSelect(
                      "billingContactNationality",
                      e ? e.value : ""
                    );
                  }}
                  className={`form-control ${
                    s.errors.billingContactNationality ? " !border-red-500" : ""
                  }`}
                  required
                  options={s.companyLookupData.countrys || []}
                />
                {s.errors.billingContactNationality && (
                  <span className="input-group-error">
                    {s.errors.billingContactNationality}
                  </span>
                )}
              </div>
              {!!s.billingContactNationality && this.isZimbabweanBilling() ? (
                <div className="input-group">
                  <label className="input-group-text">National ID</label>
                  <input
                    name="billingContactIdentification"
                    className={`form-control ${
                      s.errors.billingContactIdentification
                        ? " !border-red-500"
                        : ""
                    }`}
                    value={s?.billingContactIdentification}
                    placeholder={s.idPlaceholderBilling}
                    onChange={(e) =>
                      this.handleBillingNationalId(e.target.value)
                    }
                    required
                  />
                  {s.errors.billingContactIdentification && (
                    <span className="input-group-error">
                      {s.errors.billingContactIdentification}
                    </span>
                  )}
                </div>
              ) : !!s.billingContactNationality ? (
                <div className="input-group">
                  <label className="input-group-text">Passport Number</label>
                  <input
                    name="billingContactPassportNumber"
                    className={`form-control ${
                      s.errors.billingContactPassportNumber
                        ? " !border-red-500"
                        : ""
                    }`}
                    value={s?.billingContactPassportNumber}
                    onChange={(e) =>
                      this.handleBillingNationalId(
                        e.target.value,
                        "billingContactPassportNumber"
                      )
                    }
                    required
                  />
                  {s.errors.billingContactPassportNumber && (
                    <span className="input-group-error">
                      {s.errors.billingContactPassportNumber}
                    </span>
                  )}
                </div>
              ) : null}
            </div>
          </div>
          {/* Final section for company info and login */}
          <div className="w-full max-w-5xl mt-3">
            <div className="grid grid-cols-2 gap-x-8 gap-y-4">
              <div className="col-span-2 input-group">
                <label className="input-group-text">Physical Address</label>
                <input
                  name="physicalAddress"
                  className={`form-control ${
                    s.errors.physicalAddress ? " !border-red-500" : ""
                  }`}
                  value={s.physicalAddress}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.physicalAddress && (
                  <span className="input-group-error">
                    {s.errors.physicalAddress}
                  </span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Town/City</label>
                <Select
                  name="townCityId"
                  value={(s.companyLookupData.townCitys || []).filter(
                    ({ value }) => value === s.townCityId
                  )}
                  onChange={(e) =>
                    this.handleSelect("townCityId", e ? e.value : "")
                  }
                  className={`form-control ${
                    s.errors.townCityId ? " !border-red-500" : ""
                  }`}
                  required
                  options={s.companyLookupData.townCitys || []}
                />
                {s.errors.townCityId && (
                  <span className="input-group-error">
                    {s.errors.townCityId}
                  </span>
                )}
              </div>
              <div className="input-group">
                <label htmlFor="certOfIncorp" className="input-group-text">
                  Certificate of Incorporation
                </label>
                <input
                  name="ownershipFile"
                  className={`form-control ${
                    s.errors.ownershipFile ? " !border-red-500" : ""
                  }`}
                  type="file"
                  id="certOfIncorp"
                  onChange={this.handleChange}
                  accept=".pdf,image/*"
                />
                {s.errors.certificateOfIncorporation && (
                  <span className="input-group-error">
                    {s.errors.certificateOfIncorporation}
                  </span>
                )}
              </div>
              <div className="input-group">
                <label htmlFor="cr14" className="input-group-text">
                  CR14
                </label>
                <input
                  name="ownershipFile"
                  className={`form-control${
                    s.errors.ownershipFile ? " !border-red-500" : ""
                  }`}
                  type="file"
                  id="cr14"
                  onChange={this.handleChange}
                  accept=".pdf,image/*"
                />
                {s.errors.cr14 && (
                  <span className="input-group-error">{s.errors.cr14}</span>
                )}
              </div>
              <div></div>
              <div className="input-group">
                <label className="input-group-text">Username</label>
                <input
                  name="username"
                  className={`form-control ${
                    s.errors.username ? " !border-red-500" : ""
                  }`}
                  value={s.username}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.username && (
                  <span className="input-group-error">{s.errors.username}</span>
                )}
              </div>
              <div></div>
              <div className="input-group">
                <label className="input-group-text">Password</label>
                <input
                  name="password"
                  type="password"
                  className={`form-control ${
                    s.errors.password ? " !border-red-500" : ""
                  }`}
                  value={s.password}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.password && (
                  <span className="input-group-error">{s.errors.password}</span>
                )}
              </div>
              <div className="input-group">
                <label className="input-group-text">Password Confirm</label>
                <input
                  name="passwordConfirm"
                  type="password"
                  className={`form-control ${
                    s.errors.passwordConfirm ? " !border-red-500" : ""
                  }`}
                  value={s.passwordConfirm}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.passwordConfirm && (
                  <span className="input-group-error">
                    {s.errors.passwordConfirm}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="flex justify-center gap-8 mt-2">
            {s.valid && (
              <button type="submit" className="btn btn-success">
                Register
              </button>
            )}
            <button
              type="button"
              className="btn btn-success"
              onClick={() => window.history.back()}
            >
              Cancel
            </button>
          </div>
        </form>
        <Footer />
      </div>
    );
  }
}
